<template>
  <div class="min-h-screen bg-[#0F0F0F] text-white py-10 px-4 md:px-10">
    <div
      class="max-w-4xl mx-auto bg-[#1F1F1F] p-8 rounded-2xl shadow-xl border border-gray-700"
    >
      <h1 class="text-3xl md:text-4xl font-bold text-center mb-8">
        {{ $t("purchase-terms.purchaseTitle") }}
      </h1>

      <div class="space-y-6 text-gray-300 text-sm leading-relaxed">
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.1.title`) }}
          </h2>

          <p v-if="typeof $t(`purchase-terms.purchase.1.content`) === 'string'">
            {{ $t(`purchase-terms.purchase.1.content`) }}
          </p>
        </section>
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.2.title`) }}
          </h2>

          <p v-if="typeof $t(`purchase-terms.purchase.1.content`) === 'string'">
            {{ $t(`purchase-terms.purchase.2.content`) }}
          </p>
        </section>
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.3.title`) }}
          </h2>

          <ul class="list-disc list-inside space-y-1">
            <li>{{ $t(`purchase-terms.purchase.3.content.0`) }}</li>
            <li>{{ $t(`purchase-terms.purchase.3.content.1`) }}</li>
            <li>{{ $t(`purchase-terms.purchase.3.content.2`) }}</li>
            <li>{{ $t(`purchase-terms.purchase.3.content.3`) }}</li>
            <li>{{ $t(`purchase-terms.purchase.3.content.4`) }}</li>
          </ul>
        </section>
        <section>
          <h4 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.4.title`) }}
          </h4>

          <p v-if="typeof $t(`purchase-terms.purchase.1.content`) === 'string'">
            {{ $t(`purchase-terms.purchase.4.content`) }}
          </p>
        </section>
        <section>
          <h4 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.5.title`) }}
          </h4>

          <p v-if="typeof $t(`purchase-terms.purchase.1.content`) === 'string'">
            {{ $t(`purchase-terms.purchase.5.content`) }}
          </p>
        </section>
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.6.title`) }}
          </h2>

          <ul class="list-disc list-inside space-y-1">
            <li>{{ $t(`purchase-terms.purchase.6.content.0`) }}</li>
            <li>{{ $t(`purchase-terms.purchase.6.content.1`) }}</li>
            <li>{{ $t(`purchase-terms.purchase.6.content.2`) }}</li>
          </ul>
        </section>
        <section>
          <h4 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.7.title`) }}
          </h4>

          <p v-if="typeof $t(`purchase-terms.purchase.1.content`) === 'string'">
            {{ $t(`purchase-terms.purchase.7.content`) }}
          </p>
        </section>
        <section>
          <h4 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.8.title`) }}
          </h4>

          <p v-if="typeof $t(`purchase-terms.purchase.1.content`) === 'string'">
            {{ $t(`purchase-terms.purchase.8.content`) }}
          </p>
        </section>
        <section>
          <h4 class="text-xl font-semibold text-white mb-2">
            {{ $t(`purchase-terms.purchase.9.title`) }}
          </h4>

          <p v-if="typeof $t(`purchase-terms.purchase.1.content`) === 'string'">
            {{ $t(`purchase-terms.purchase.9.content`) }}
          </p>
        </section>
      </div>

      <div class="mt-10 text-center text-gray-500 text-xs">
        © {{ new Date().getFullYear() }} MEM22 Akademi. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: "default" });
</script>
